import { checkHttpStatus, parseJSON, DEFAULT_HEADERS } from '../Utils/actions';
import * as endpoints from '../constants/endpoints'
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export function skuAction(method, callback, error, skuMapping) {
    var url = endpoints.SKU_MAPPINGS_ENDPOINT,
        parseFunc = method !== 'delete' ? parseJSON: '';
    if (method === 'put' || method === 'delete') {
        url += '/' + skuMapping.id;
        delete skuMapping.id;
    }
    return fetch(url, {
        method: method,
        headers: {'Accept': '*/*','Content-Type': 'application/json-patch+json','Authorization': `Bearer ${cookies.get('rawtoken')}`},
        body: method === 'put' || method === 'post' ? JSON.stringify(skuMapping) : ''
    })
        .then(checkHttpStatus)
        .then(parseFunc)
        .then(response => {
            try {
                callback(response);
            } catch (e) {
                console.log(e)
                error(e);
            }
        })
        .catch(e => {
            console.log(e)
            error(e);
        })
}
export function getProducts(type, callback, error) {
    var url = type === 'distributors' ? endpoints.DISTRIBUTOR_PRODUCTS_ENDPOINT : type === 'hermes' ? endpoints.HERMES_SKU_ENDPOINTS : '';
    return fetch(url, {
        method: 'get',
        headers: {'Accept': '*/*','Content-Type': 'application/json-patch+json','Authorization': `Bearer ${cookies.get('rawtoken')}`}
    })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then(response => {
            try {
                callback(response);
            } catch (e) {
                console.log(e)
                error(e);
            }
        })
        .catch(e => {
            console.log(e)
            error(e);
        })
}